import styled, { css } from 'styled-components';
import { getSpacing, getColorAlias, getFontSize } from '../../utils/index.js';

const DefaultListItemWrapper = styled.li `
  display: flex;
  width: 100%;
  min-height: ${getSpacing('s08')};
  padding: ${getSpacing('s02')};
  background-color: ${getColorAlias('containerDefault')};
  color: ${getColorAlias('contentDefault')};
  list-style-type: none;
  border-bottom: ${({ divider, theme }) => divider ? `1px solid ${getColorAlias('borderDefault', theme)}` : 'none'};
`;
const CompactListItemWrapper = styled(DefaultListItemWrapper) `
  min-height: ${getSpacing('s07')};
`;
const MultiLineListItemWrapper = styled(DefaultListItemWrapper) `
  min-height: ${getSpacing('s09')};
`;
const ListItemFlexContainer = styled.div `
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  flex: 1;
`;
styled.div `
  height: 100%;
  padding-inline: ${getSpacing('s02')};
  display: flex;
  align-items: ${(props) => (props.type === 'action' ? 'baseline' : 'center')};
  justify-content: center;

  div {
    margin: 0;
  }

  svg {
    ${getFontSize('size20')};
    fill: ${getColorAlias('interactivePrimary')};
  }

  img {
    ${(props) => props.type === 'thumbnail'
    ? css `
            height: ${getSpacing('s09')};
            width: ${getSpacing('s09')};
          `
    : css `
            height: ${getSpacing('s07')};
            width: ${getSpacing('s07')};
          `}
    object-fit: cover;
    ${(props) => props.type === 'avatar' &&
    css `
        clip-path: circle();
      `}
  }
`;
styled.div `
  padding-inline: ${getSpacing('s02')};

  flex: 1 2 60%;
  flex-direction: column;
`;
const ListItemPrimaryText = styled.p `
  margin: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  overflow: hidden;
`;
const ListItemSecondaryText = styled(ListItemPrimaryText) `
  color: ${getColorAlias('contentSubdued')};
  ${getFontSize('size14')};

  -webkit-line-clamp: 2;
`;
const sharedSuffixPositioning = css `
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;
styled(ListItemSecondaryText) `
  ${sharedSuffixPositioning}

  align-self: baseline;
  ${getFontSize('size14')};
`;
styled.div `
  ${sharedSuffixPositioning}

  flex-basis: 25%;

  svg {
    ${getFontSize('size24')};
    fill: ${getColorAlias('interactivePrimary')};
  }
`;

export { CompactListItemWrapper, DefaultListItemWrapper, ListItemFlexContainer, ListItemPrimaryText, ListItemSecondaryText, MultiLineListItemWrapper };
